import { Order } from '@cemex-core/cmx-api/models/order-management/order';
import {
  OrderSelectedDetailActions,
  ModifyOrderSelectedDetailActionTypes,
} from '@ordersnproducts/modules/new-modify-order/actions/order-detail.actions';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { isSameDay } from 'app/calendar-view/utils';
import * as moment from 'moment';

export interface OrderSelectedDetailState {
  loaded: boolean;
  loading: boolean;
  order: Order;
  prefilledOrder: {
    enabled: boolean;
  };
  prices: OrderPrices;
  isDeliveryToday: boolean;
}

export interface OrderPrices {
  taxes: number;
  amount: number;
  totalAmount: number;
}

export const initialState: OrderSelectedDetailState = {
  loaded: false,
  loading: false,
  order: null,
  prefilledOrder: undefined,
  prices: null,
  isDeliveryToday: false,
};

export function reducer(
  state = initialState,
  action: OrderSelectedDetailActions | OrderBuilderActions,
): OrderSelectedDetailState {
  switch (action.type) {
    case ModifyOrderSelectedDetailActionTypes.UPDATE: {
      return {
        ...state,
        order: {
          ...state.order,
          ...action.payload,
        },
      };
    }
    case ModifyOrderSelectedDetailActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      };
    }
    case ModifyOrderSelectedDetailActionTypes.LOAD_SUCCESS: {
      return {
        ...state,
        loading: false,
        order: {
          ...action.payload['orders'][0],
        },
        isDeliveryToday: isSameDay(
          moment
            .utc(_safe(() => action.payload['orders'][0].programmedDateTime))
            .local()
            .format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
        ),
        prices: {
          taxes: action.payload['orders'][0].taxes,
          amount: action.payload['orders'][0].amount,
          totalAmount: action.payload['orders'][0].totalAmount,
        },
        prefilledOrder: {
          enabled: true,
        },
      };
    }
    case ModifyOrderSelectedDetailActionTypes.LOSET_PREFILLED_ORDER: {
      return {
        ...state,
        prefilledOrder: {
          enabled: false,
        },
      };
    }
    case ModifyOrderSelectedDetailActionTypes.RESET_WO_PRICES: {
      return {
        ...initialState,
        prices: state.prices,
        isDeliveryToday: state.isDeliveryToday,
      };
    }
    case RESET_BUILDER:
    case ModifyOrderSelectedDetailActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
